
<div class="resources-container flex flex-row gap-5 justify-between px-10 font-rubik">
  <div class="w-full resources-colors-container flex flex-col justify-between py-6">
    <div class="w-full">
      <p class="resources-text mb-1">MODIFY CONTAINERS</p>
      <p class="resources-text">TO FIT <span :class="'resources-text-' + selectedColor">YOUR NEEDS.</span></p>
    </div>
    <div class="w-full flex flex-row justify-between items-center gap-4">
      <div class="resources-colors" style="background-color: #3565FC;" @click="changeColor('blue')"></div>
      <div class="resources-colors" style="background-color: #06B6D4;" @click="changeColor('aqua')"></div>
      <div class="resources-colors" style="background-color: #14B8A6;" @click="changeColor('green')"></div>
      <div class="resources-colors" style="background-color: #84CC16;" @click="changeColor('lime')"></div>
    </div>
  </div>

  <a href="/container-modifications" class="w-full flex flex-row items-end py-3">
    <img :class="selectedColor == 'blue' ? 'resources-bg-img' : 'hidden'" src="@/images/header/dropdown-resouces-img-01.png" alt="Resources">
    <img :class="selectedColor == 'aqua' ? 'resources-bg-img' : 'hidden'" src="@/images/header/dropdown-resouces-img-02.png" alt="Resources">
    <img :class="selectedColor == 'green' ? 'resources-bg-img' : 'hidden'" src="@/images/header/dropdown-resouces-img-03.png" alt="Resources">
    <img :class="selectedColor == 'lime' ? 'resources-bg-img' : 'hidden'" src="@/images/header/dropdown-resouces-img-04.png" alt="Resources">
    <button :class="'go-to-resources-btn go-to-resources-btn-' + selectedColor + ' flex justify-center items-center mb-5 ml-2'">
      <img src="@/images/header/arrow-forward.svg" alt="Go to Resources page">
    </button>
  </a>
</div>
